import React, { PureComponent, Fragment } from 'react';
import CloseSvg from '../../../shared/UI/closeSvg';
import ButtonSpinner from '../../../shared/UI/button-spinner';
import { DeleteSector } from '../../../../actions/booking';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import InfoSvg from '../../../shared/UI/infoSvg';
import CloseRoundSvg from '../../../shared/UI/closeRoundSvg';
ReactModal.setAppElement('#root');

class DeleteSectorPanel extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            isSubmitting:false,
            showErrorModal:false
        }
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.confirmPromptModal = this.confirmPromptModal.bind(this);
    }

    componentWillUnmount(){
        this.setState({isSubmitting:false, showErrorModal:false});
    }

    openModal(){ this.setState({showErrorModal:true}); }
    closeModal(){ this.setState({showErrorModal:false}); }


    confirmPromptModal(){
        const { filteredItinerary, client, uuid, currentStop, closeSlidePanel, isLoading } = this.props;

        this.setState({isSubmitting:true});
        
        closeSlidePanel(null);

        setTimeout(() => {
            if(!isLoading) DeleteSector(client, uuid, filteredItinerary[currentStop].id);
        }, 300);

    }

    render(){

        const { showErrorModal, isSubmitting } = this.state;

        return (
            <Fragment>
                <div className="clearfix">
                    <div className="col col-12">
                        <button type="button" className="delete-sector-btn" onClick={this.openModal}>
                        <CloseSvg />  Delete Sector    
                        </button>
                    </div>
                </div>

                {
                    showErrorModal && (
                        <ReactModal
                            className="include-modal basket"
                            overlayClassName="modal-overlay semi-white"
                            isOpen={showErrorModal}
                            onRequestClose={this.closeModal}
                            contentLabel="Include modal">
                    
                            <div className="max-width-5 mx-auto clearfix">
                                <div className="col col-12 center">

                                    <InfoSvg />

                                    <h4 className="mb1 mt2">Hey Wait!</h4>
                                    <p className="medium margin-b-30">Are you sure you want to delete?</p>
                                    <button type="button" className="busabout--cta orange rounded-corner inline" onClick={this.confirmPromptModal} disabled={isSubmitting}>
                                        { !isSubmitting && <>Confirm</> }
                                        { isSubmitting &&  <ButtonSpinner /> } 
                                    </button>
                                </div>
                        
                                <div className="col col-12 px2">
                                    <button className="modal-close" onClick={this.closeModal}><CloseRoundSvg /></button>
                                </div>
                            </div>
                    
                        </ReactModal>
                    )
                }

            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return{
        uuid:state.currentBooking.uuid,
        filteredItinerary:state.currentBooking.filteredItinerary,
        isLoading:state.cart.update_sector_loading
    }
}
  
export default withApollo(connect(mapStateToProps, null)(DeleteSectorPanel));